














import { computed, defineComponent } from '@vue/composition-api';
import HtmlModal from '@/components/UI/HtmlModal.vue';
import { useStore } from '@/store';
import { MutationTypes } from '@/store/mutations';
import { ActionTypes } from '@/store/actions';

export default defineComponent({
    name: 'DeleteCarModal',
    components: { HtmlModal },
    setup () {
        const store = useStore();
        const isOpened = computed(() => store.state.deleteCarModal.isOpened);
        const index = computed(() => store.state.deleteCarModal.index);
        const close = () => {
            store.commit(MutationTypes.CloseDeleteCarModal);
        };
        const deleteFromCompare = () => {
            store.dispatch(ActionTypes.RemoveItemFromCompareList, index.value);
            close();
        };
        const deleteCompletely = () => {
            store.dispatch(ActionTypes.RemoveItemFromCompareCompletely, index.value);
            close();
        };
        return { isOpened, close, deleteFromCompare, deleteCompletely };
    }
});
